import React from 'react';

import isEmpty from 'lodash/isEmpty';

import {
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  TableContainer,
} from '@gogame/components';

import {
  LabelCBudget,
  LabelInline,
} from 'scenes/MarketingPlanning/MarketingPlanningWizard/components';
import { GroupSubNodeProvider } from 'scenes/MarketingPlanning/MarketingPlanningWizard/components/Group';
import { useViewStateByResolveName } from 'scenes/MarketingPlanning/MarketingPlanningWizard/components/ViewState';

import Row from './Row';

const NodesBudgetGrid = ({
  withLinkName = true,
  withCBudgetEmptyPlaceholder = false,
}) => {
  const { nodes, metricTypes } = useViewStateByResolveName();

  if (isEmpty(nodes)) {
    return null;
  }

  return (
    <TableContainer>
      <Table
        leftStickyColumnCount={2}
        striped={true}
        stickyHeader={true}
        size={'small'}
        name={'previewNodesBudgetTable'}
      >
        <TableHead>
          <TableRow>
            <TableCell columnTitle={'name'}>Name</TableCell>
            <TableCell width={4} padding={'none'} />
            <TableCell align={'right'} columnTitle={'cBudget'}>
              <LabelCBudget />
            </TableCell>
            <TableCell align={'right'} columnTitle={'Budget'}>
              Budget
            </TableCell>
            <TableCell align={'right'} columnTitle={'Budget, %'}>
              <LabelInline>Budget, %</LabelInline>
            </TableCell>
            <TableCell align={'right'} columnTitle={'Daily Pace<'}>
              <LabelInline>Daily Pace</LabelInline>
            </TableCell>
            {metricTypes.map(({ id, name }) => {
              return (
                <React.Fragment key={`nodes_table_head_cell_${id}`}>
                  <TableCell align={'right'} columnTitle={name}>
                    <LabelInline>{name}</LabelInline>
                  </TableCell>
                  <TableCell align={'right'} columnTitle={`c${name}`}>
                    <LabelInline>{`c${name}`}</LabelInline>
                  </TableCell>
                </React.Fragment>
              );
            })}
            <TableCell columnTitle={'Comment'}>Comment</TableCell>
            <TableCell width={'100%'} />
          </TableRow>
        </TableHead>
        <TableBody>
          {nodes.map(({ entityId, activityTypes, nodes }, i) => {
            const activityTypesList = Object.keys(activityTypes);
            return (
              <GroupSubNodeProvider key={`nodes_table_row_${i}`} nodeIndex={i}>
                {activityTypesList.map((type, i) => (
                  <Row
                    key={type}
                    entityId={entityId}
                    activityType={type}
                    activityTypeIndex={i}
                    activityTypeLength={activityTypesList.length}
                    withLinkName={withLinkName}
                    withCBudgetEmpty={
                      withCBudgetEmptyPlaceholder && isEmpty(nodes)
                    }
                  />
                ))}
              </GroupSubNodeProvider>
            );
          })}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default NodesBudgetGrid;
